import $ from 'jquery';

const LOGIN_BOX_POPIN = {
    SELECTOR_PARENT: '.js-container-popin',
    SELECTOR_POPIN: '.js-notif-box',
    CLASS_POPIN: 'js-notif-box',
    SELECTOR_HEADLINE: '.js-notif-box-title',
    SELECTOR_DESCRIPTION: '.js-notif-box-description',
    SELECTOR_LINK: ".js-notif-box-link",
    SELECTOR_BTN_CLOSE: ".js-notif-box-close"
}

const POPIN_DEFAULT_VALUES = {
    MOBILE_BREAKPOINT: 768,
    MOBILE_ID_AFTER_CONTAINER: "#go-content"
}

export default class Popin {

    constructor(selectorContainer, currentApp, priorityMobile, multipleStage = false) {
        var _self = this;
        _self.currentApp = currentApp;
        _self.isActive = false;
        _self.isOpen = false;

        // HTML DOM
        _self.$elt = $(LOGIN_BOX_POPIN.SELECTOR_POPIN);
        _self.$popin = _self.$elt.clone();
        _self.$popin.removeClass(LOGIN_BOX_POPIN.CLASS_POPIN);

        // Init priority property for mobile
        _self.priorityMobile = priorityMobile;

        // MultiStage context
        _self.multipleStage = multipleStage;
        _self.firstLvlClosed = false;

        // Init Mobile context
        _self.onMobile = false;
        if ($(window).width() < POPIN_DEFAULT_VALUES.MOBILE_BREAKPOINT) {
            _self.onMobile = true;
        }

        // Init popin with generic structure - Hide by default
        _self.$container = $(LOGIN_BOX_POPIN.SELECTOR_PARENT);
        _self.$container.append(_self.$popin);
        _self.hide();

        // Init Each HMTL Element
        _self.$headLine = _self.$popin.find(LOGIN_BOX_POPIN.SELECTOR_HEADLINE);
        _self.$description = _self.$popin.find(LOGIN_BOX_POPIN.SELECTOR_DESCRIPTION);
        _self.$link = _self.$popin.find(LOGIN_BOX_POPIN.SELECTOR_LINK);
        _self.$btnClose = _self.$popin.find(LOGIN_BOX_POPIN.SELECTOR_BTN_CLOSE);
        _self.$moreWithLink = _self.$popin.find(LOGIN_BOX_POPIN.SELECTOR_MORE_WITH_LINK);

        window.EventBusCMS.addEventListener('nextPopinToShow', event => {
            if ((event.detail.priorityToDisplay === _self.priorityMobile) && (_self.isActive)){
                _self.show();
            }
        });

        // bind btn close
        _self.$btnClose.bind("click", function () {
            _self.hide();

            // specific popin with multiple stage
            if (_self.multipleStage && !_self.firstLvlClosed) {
                window.EventBusCMS.dispatchEvent('popinEvent', {firstLvlClosed : true, currentApp : _self.currentApp});
                _self.firstLvlClosed = true;
            }

            // specific popin with multiple stage
            window.EventBusCMS.dispatchEvent('popinGenericEventOnClose', {currentApp : _self.currentApp});

            // generate event to display other popin by priority on mobile
            if (_self.onMobile) {
                _self.displayNextPopin();
            }
        });
    }

    displayNextPopin() {
        var priorityToDisplay = this.priorityMobile + 1;
        // specific popin with multiple stage
        window.EventBusCMS.dispatchEvent('nextPopinToShow', {priorityToDisplay : priorityToDisplay});
    }

    hide() {
        this.isActive = false;
        this.isOpen = false;
        this.$popin.removeClass('is-open');
    }

    activate() {
        this.isActive = true;
    }

    show() {
        this.isActive = true;
        this.isOpen = true;
        this.$popin.addClass('is-open');
        this.$container.addClass('is-open');
    }

    updatePopinData(data) {
        var _self = this;

        _self.updateHeadLine(data.headLine);
        _self.updateDescription(data.description);
        if (data.hideLink) {
            _self.hideLink();
        } else {
            _self.updateLink(data.href);
            _self.updateTextLink(data.textLink);
        }
    }

    hideLink() {
        if (this.$moreWithLink.length) {
            this.$moreWithLink.hide();
        }
    }

    updateHeadLine(txt) {
        if (this.$headLine.length) {
            this.$headLine.text(txt);
        }
    }

    updateDescription(txt) {
        if (this.$description.length) {
            this.$description.html(txt);
        }
    }

    updateLink(href) {
        if (this.$link.length) {
            this.$link.attr("href", href);
        }
    }

    updateTextLink(txt) {
        if (this.$link.length) {
            this.$link.text(txt);
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/cms/commons/loginbox/popin/generic/popin.js